import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import VueFirestore from 'vue-firestore'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import App from './App.vue'
import router from './router';
import store from './store';
import { fb, db, fcm } from './services/firebase';
import EventDetails from './components/EventDetails';
import EventGenerateTeams from './components/EventGenerateTeams';
import DateFilter from './filters/date';
import './registerServiceWorker'


Vue.config.productionTip = false
Vue.use(VueFirestore);
Vue.component('EventDetails', EventDetails);
Vue.component('EventGenerateTeams', EventGenerateTeams);
Vue.filter('date', DateFilter)

let app;
fb.auth().onAuthStateChanged(function(user) {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }

  if (user) {
    const userData = user.toJSON();
    const userRef = db.collection('users').doc(userData.uid);
    store.commit('setUserAuthData', userData);
    userRef.get().then((res) => {
      const userData = res.data();
      store.commit('setUserData', userData);
      // Add the public key generated from the console here.
      fcm.usePublicVapidKey(process.env.VUE_APP_FIREBASE_PUBLIC_VAPID_KEY);
      fcm.requestPermission().then(async function() {
          console.log('Notification permission granted.');
          const token = await fcm.getToken();
          console.log('token:', token);
          userRef.update({
              fcmToken: token
          });
      }).catch(function(err) {
          console.log('Unable to get permission to notify.', err);
      });

      // Callback fired if Instance ID token is updated.
      fcm.onTokenRefresh(async function() {
          const token = await fcm.getToken();
          console.log('new token:', token);
          userRef.update({
              fcmToken: token
          });
      });
    }).catch(() => {
      // show error
    });
  }
});


